import styled from 'styled-components';

const Title = styled.a`
  color: #000;
  font-size: 20px;
  text-align: center;
  font-family: 'Space Mono', monospace;
  @media only screen and (min-width: 768px) {
    padding: 0 10px;
    font-size: 22px;
  }
`;
export default Title;
